import type { Attachment } from '@billy/design-system'

import type { EInvoiceStatus } from '@features/eInvoicing/constants'
import { getEInvoiceLifecycleFromDataJson } from '@features/eInvoicing/utils/getEInvoiceLifecycleFromDataJson'

import { AttachmentType } from '../enums/attachmentType'

export const getAttachmentEInvoiceStatus = (attachment: Attachment): EInvoiceStatus | null => {
  if (attachment.type !== AttachmentType.EDocument || !attachment.file?.dataJson) {
    return null
  }

  return getEInvoiceLifecycleFromDataJson(attachment.file.dataJson)?.eInvoiceStatus ?? null
}
